import { createQuery } from '@datorama/akita';
import store from 'state/UI/store';

export const query = createQuery(store)

export const state$ = query.select();
export const loading$ = query.selectLoading();